// Environment configuration
export const config = {
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  siteUrl:
    (import.meta.env.VITE_SITE_URL as string | undefined)?.replace(
      /\/+$/,
      ""
    ) || "https://www.travelwingsonline.in",
  // Use Azure Web App backend directly for all environments
  backendUrl:
    import.meta.env.VITE_API_BASE_URL ||
    (import.meta.env.PROD
      ? "https://travelwings-web-as-dudgh8hsaag3emgp.canadacentral-01.azurewebsites.net"
      : "http://localhost:5000"),
};

// Default export for compatibility
export default config;

// Helper function to build API URLs
export function buildApiUrl(endpoint: string): string {
  // Always use Azure Web App backend directly
  const baseUrl = config.backendUrl;

  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint.slice(1) : endpoint;
  const finalUrl = `${baseUrl}/${cleanEndpoint}`;

  return finalUrl;
}

// Helper function to get auth headers
export function getAuthHeaders(): Record<string, string> {
  const token = localStorage.getItem("authToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// API request helper
export async function apiRequest(
  method: string,
  endpoint: string,
  data?: any,
  options: RequestInit = {}
): Promise<Response> {
  const url = buildApiUrl(endpoint);
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  if (options.headers && !Array.isArray(options.headers)) {
    Object.assign(headers, options.headers as Record<string, string>);
  }

  const config: RequestInit = {
    method,
    headers,
    ...options,
  };

  if (data && method !== "GET") {
    config.body = JSON.stringify(data);
  }

  const response = await fetch(url, config);

  if (!response.ok) {
    const errorText = await response.text();
    console.error("API Error:", {
      status: response.status,
      statusText: response.statusText,
      errorText,
    });

    // Enhanced error for package creation specifically
    if (endpoint.includes("/api/packages") && method === "POST") {
      throw new Error(
        `Azure backend package creation failed (${response.status}). This is a known backend issue. Package creation works perfectly on local development.`
      );
    }

    throw new Error(
      `Request failed: ${response.status} ${response.statusText}${
        errorText ? ` - ${errorText}` : ""
      }`
    );
  }

  return response;
}
